import React from 'react'
import styled from "styled-components"
import HorizontalAlign from "./horizontalAlign"
import LabelInput from "./labelInput"
import Input from "./input"
import ButtonForm from "./buttonForm"
import {RadioButton, RadioGroup} from "react-radio-buttons"

const StyledDiv = styled.div`
  width: 45%;
`

const FormClub = (
    {
        handleSubmit = null,
        handleChange = null,
        handleChangeFile = null,
        handleChangeRadio = null,
        club = {},
        affiliation = null
    }) => {
    return (
        <form onSubmit={handleSubmit}>
            <HorizontalAlign content={
                <>
                    <StyledDiv>
                        <LabelInput content="Nom du club" redStar={true}/>
                        <Input name="nom" onChange={handleChange} defaultValue={club.nom}/>
                        <LabelInput content="Pays" redStar={true}/>
                        <Input name="pays" onChange={handleChange} defaultValue={club.pays}/>
                    </StyledDiv>
                    <StyledDiv>
                        <LabelInput content="Est-il affilié à la fédération ?" redStar={true}/>
                        <RadioGroup onChange={handleChangeRadio} name="affiliation" horizontal value={affiliation}>
                            <RadioButton value="true" rootColor="#4466ca" pointColor={"#171d45"}>Oui</RadioButton>
                            <RadioButton value="false" rootColor="#4466ca" pointColor={"#171d45"}>Non</RadioButton>
                        </RadioGroup><br/>
                        <LabelInput content="Modifier la photo"/>
                        <Input onChange={handleChangeFile} name="file" type="file"/>
                    </StyledDiv>
                </>
            }
            />
            <ButtonForm value="Modifier les informations"/>
        </form>
    )
}

export default FormClub
